import React, { useState, useContext, useEffect } from "react";
import { TokenContext } from "./TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "./ModalComponent";
import Repo from "../Utility/Repo";
import UploadFile from "../Components/UploadFile";

function AllegatiComponent({
  entityId,
  tipoEntity,
  isOperator,
  targetEntityId,
  targetEntityType = "User",
}) {
  const apiToken = useContext(TokenContext);

  const [showModalAdd, setshowModalAdd] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [fileName, setFilename] = useState("");

  const [error, setError] = useState("");
  const initialFormData = {
    storageFileId: "",
    nomeFile: "",
    descrizione: "",
  };
  const [fileBase64, setFileBase64] = useState();
  const [formData, setFormData] = useState(initialFormData);
  const [formDataList, setFormDataList] = useState([]);

  const [file, setFile] = useState();
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [loadingFileId, setLoadingFileId] = useState(null);
  const [transferLoading, setTransferLoading] = useState({
    fileId: null,
    action: "",
  });

  const loadData = () => {
    if (entityId != null) {
      Repo.getAllegatiEntity(apiToken, tipoEntity, entityId)
        .then((response) => {
          setFormDataList(response.data);
          // setLoading(true);
        })
        .catch((error) => {
          // setLoading(true);
          Repo.handleApiError(error, setError);
        });
    }
  };

  useEffect(() => {
    // Definisci la funzione per la richiesta GET
    loadData();

    // Cleanup della funzione se necessario (ad esempio, per cancellare sottoscrizioni o timeout)
    return () => {
      // Operazioni di cleanup, se necessario
    };
  }, []); // L'array vuoto [] indica che useEffect deve essere eseguito solo al montaggio del componente

  const resetFormFields = () => {
    setFormData(initialFormData);
    setError("");
  };

  const toggleModalAdd = () => {
    setshowModalAdd((prevShowModalAdd) => !prevShowModalAdd);
    resetFormFields();
  };

  const handleCloseModalAdd = () => {
    setshowModalAdd(false);
    resetFormFields();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const showAdd = () => {
    setshowModalAdd(true);
  };

  const getFileTitle = (nomeFile) =>
    nomeFile.includes(";") ? nomeFile.split(";")[0] : nomeFile;

  const getFileDescription = (nomeFile) =>
    nomeFile.includes(";") ? nomeFile.split(";")[1] : "";

  const base64ToFile = (base64Data, filename, mimeType = "application/pdf") => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], filename, { type: mimeType });
  };

  const canMoveOrCopyToSocialFolder =
    tipoEntity === "Subscription" && !!targetEntityId;

  const moveOrCopyAttachmentToSocialFolder = async (allegato, action) => {
    if (!canMoveOrCopyToSocialFolder || !allegato?.storageFileId) {
      return;
    }

    try {
      setTransferLoading({ fileId: allegato.storageFileId, action });

      const fileResponse = await Repo.getFileAllegato(
        apiToken,
        allegato.storageFileId,
      );
      const fileTitle = getFileTitle(allegato.nomeFile || "allegato.pdf");
      const fileDescription = getFileDescription(allegato.nomeFile || "");

      const safeFileName = fileTitle.toLowerCase().endsWith(".pdf")
        ? fileTitle
        : `${fileTitle}.pdf`;

      const fileToUpload = base64ToFile(
        fileResponse.data,
        safeFileName,
        "application/pdf",
      );

      await Repo.postInsertAllegato(
        apiToken,
        targetEntityType,
        targetEntityId,
        fileDescription,
        fileToUpload,
      );

      if (action === "move") {
        await Repo.postDeleteAllegato(apiToken, allegato.storageFileId);
        loadData();
      }

      alert(
        action === "move"
          ? "Allegato spostato in cartella sociale"
          : "Allegato copiato in cartella sociale",
      );
    } catch (err) {
      Repo.handleApiError(err, setError);
    } finally {
      setTransferLoading({ fileId: null, action: "" });
    }
  };

  const handleDelete = (recordId, titolo) => {
    const confirmDelete = window.confirm(
      `Sei sicuro di voler eliminare ${titolo}?`,
    );

    if (confirmDelete) {
      // Chiamata API per eliminare il record
      Repo.postDeleteAllegato(apiToken, recordId)
        .then((response) => {
          if (titolo.toLowerCase().startsWith("trasmissione_")) {
            window.location.reload();
          }
          if (response.status === 204) {
            // Aggiorna lo stato o effettua altre azioni dopo l'eliminazione
            // Ad esempio, puoi ricaricare i dati o aggiornare il componente.
            loadData();
          }
        })
        .catch((error) => {
          Repo.handleApiError(error, setError);
        });
    }
  };

  const handleSave = () => {
    Repo.postInsertAllegato(
      apiToken,
      tipoEntity,
      entityId,
      formData.descrizione,
      file,
    )
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          loadData();
        }
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
      });

    resetFormFields();
  };

  const downloadBase64File = (
    base64,
    filename,
    mimeType = "application/pdf",
  ) => {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      alert("Errore durante il download del file.");
    }
  };

  const bodyFile = () => {
    if (loadingFileId) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "2.5rem", height: "2.5rem" }}
          >
            <span className="sr-only">Caricamento...</span>
          </div>
          <p className="mt-3 mb-0 font-weight-bold">Caricamento allegato...</p>
        </div>
      );
    }
    if (file && file.data && file.data.length > 2_000_000) {
      return (
        <div className="text-center mt-3">
          <p>
            Il file è troppo grande per essere visualizzato direttamente nel
            browser.
          </p>
          <button
            className="btn btn-primary"
            onClick={() =>
              downloadBase64File(
                file.data.replace(/^data:application\/pdf;base64,/, ""),
                fileName || "allegato.pdf",
                file.type || "application/pdf",
              )
            }
          >
            Scarica il file
          </button>
        </div>
      );
    }
    return (
      <object
        width="100%"
        height="900"
        data={file && file?.data}
        type={file && file.type}
      ></object>
    );
  };

  const downloadFile = (id) => {
    setLoadingFileId(true);
    toggleModalShowFile(!showFileToggle);
    Repo.getFileAllegato(apiToken, id)
      .then((response) => {
        if (response.status === 200) {
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);
        }
      })
      .catch((error) => {
        // Gestione dell'errore
        Repo.handleApiError(error, setError);
      })
      .finally(() => {
        setLoadingFileId(false);
      });

    // resetFormFields();
  };

  const bodyAdd = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="descrizione">Descrizione:</label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={formData.descrizione}
                onChange={handleChange}
                rows={4} // Imposta il numero di righe desiderato
              />
            </div>

            <div className="row">
              <div className="col-12 d-flex justify-content-center mt-4">
                <UploadFile
                  setErrorMessage={setErrorMessage}
                  typeFile={[
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ]}
                  handleFile={setFileBase64}
                  handleFileUploaded={setFile}
                  nameFile={setFilename}
                ></UploadFile>
                {errorMessage && (
                  <div className="text-danger">
                    Carica un file con un formato supportato
                  </div>
                )}
              </div>
            </div>
            {fileBase64 && (
              <object
                className="mt-5"
                width="100%"
                height="900"
                data={fileBase64}
                type="application/pdf"
              ></object>
            )}
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="row no_print">
      <div className="col-lg-12 mt-3">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after card-big roundedCustom">
            <div className="etichetta">
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus`}></use>
              </svg>
              <span>
                <a
                  className="text-decoration-none"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    showAdd();
                  }}
                >
                  Aggiungi
                </a>
              </span>
            </div>

            <div className="card-body">
              <h4>Allegati</h4>

              <div className="container">
                <div className="row row-cols-2">
                  {formDataList && formDataList.length > 0 ? (
                    formDataList.map((allegato, index) => (
                      <div className="col" key={index}>
                        <div className="d-flex justify-content-end btn-delete-file">
                          {canMoveOrCopyToSocialFolder && (
                            <>
                              <button
                                className="btn btn-xs p-0"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Copia in cartella sociale"
                                disabled={
                                  transferLoading.fileId ===
                                  allegato.storageFileId
                                }
                                onClick={() =>
                                  moveOrCopyAttachmentToSocialFolder(
                                    allegato,
                                    "copy",
                                  )
                                }
                              >
                                <svg className="icon icon-primary icon-s p-1">
                                  <use href={`${iconSprite}#it-copy`} />
                                </svg>
                              </button>
                              <button
                                className="btn btn-xs p-0"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Sposta in cartella sociale"
                                disabled={
                                  transferLoading.fileId ===
                                  allegato.storageFileId
                                }
                                onClick={() =>
                                  moveOrCopyAttachmentToSocialFolder(
                                    allegato,
                                    "move",
                                  )
                                }
                              >
                                <svg className="icon icon-warning icon-s p-1">
                                  <use
                                    href={`${iconSprite}#it-external-link`}
                                  />
                                </svg>
                              </button>
                            </>
                          )}
                          {allegato?.nomeFile
                            ?.toLowerCase()
                            .includes("trasmissione_") && !isOperator ? (
                            <button
                              className="btn btn-xs p-0"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Non è possibile eliminare allegati generati in modo automatico"
                              disabled={true}
                            >
                              <svg className="icon icon-secondary icon-s">
                                <use href={`${iconSprite}#it-close`} />
                              </svg>
                            </button>
                          ) : (
                            <button
                              className="btn btn-xs p-0"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Cancella"
                              onClick={() =>
                                handleDelete(
                                  allegato.storageFileId,
                                  getFileTitle(allegato.nomeFile),
                                )
                              }
                            >
                              <svg className="icon icon-danger icon-s">
                                <use href={`${iconSprite}#it-close`} />
                              </svg>
                            </button>
                          )}
                        </div>
                        <div className="categoryicon-top mb-0 row">
                          <div className="col-10 p-0">
                            <svg className="icon p-1 m-0">
                              <use href={`${iconSprite}#it-clip`}></use>
                            </svg>

                            <span className="text ms-1">
                              <a
                                href="#"
                                className="text-decoration-none font-weight-bold"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (loadingFileId === allegato.storageFileId)
                                    return;
                                  downloadFile(allegato.storageFileId);
                                }}
                              >
                                {getFileTitle(allegato.nomeFile)}
                              </a>
                            </span>
                          </div>
                        </div>

                        <p className="card-text font-serif ms-1">
                          {getFileDescription(allegato.nomeFile) ||
                            allegato.nomeFile}
                        </p>
                      </div>
                    ))
                  ) : (
                    <>Non sono stati caricati allegati.</>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <ModalComponent
        toggleModal={toggleModalAdd}
        id="addFileId"
        isOpen={showModalAdd}
        header="Inserisci un nuovo allegato"
        body={bodyAdd()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalAdd}
        function={() => handleSave()}
        buttonConfirm="Salva"
      />

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>
    </div>
  );
}

export default AllegatiComponent;
